module.exports = __webpack_public_path__ + "/images/ico-color-ciguena.accb24f.svg";